import { render } from "./TheFooter.vue?vue&type=template&id=318c2de8&ts=true"
import script from "./TheFooter.vue?vue&type=script&lang=ts"
export * from "./TheFooter.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3780260707/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__